import React from 'react';
import { PerformanceTabContent } from './PerformanceTabContent';
import { ProfilePerformanceItem } from './ProfilePerformanceItem';
import { Divider } from '@medely/ui-kit';

type AttendanceInfoProps = {
  noShowsCount: number;
  lateCancellationsCount: number;
  link: string;
};

export const AttendanceInfo = ({
  noShowsCount,
  lateCancellationsCount,
  link,
}: AttendanceInfoProps) => {
  return (
    <>
      <PerformanceTabContent title="Within last 365 days">
        <ProfilePerformanceItem
          title="No-shows"
          description="Can't make a shift? Always cancel it. No Shows put the patient at risk. Any No Show will affect your account’s access to Medely’s shifts and assignments."
          count={noShowsCount}
          link={link}
        />
        <Divider />
        <ProfilePerformanceItem
          title="Late cancellations"
          description="Pro tip: You have a 30-minute grace period after booking a shift to cancel without affecting your account. Shifts canceled after the grace period but within 24 hours of the start of the shift are late cancellations."
          count={lateCancellationsCount}
          link={link}
        />
      </PerformanceTabContent>
    </>
  );
};
